module.exports = __webpack_public_path__ + "img/72fc039eba5fd152194eeeee9599adbb.png";